import CalculatePayroll from '@/api/hr/calculate-payroll'
import OrgChartStructure from '@/api/hr/hris-org-chart-structure'
import Employee from '@/api/hr/employee'
import ShiftManagement from '@/api/hr/shift-management'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  cycle_year: moment().format('YYYY'),
  cycle_month: moment().format('MM'),
  orgChartStructures: [],
  employees: [],
  shifts: [],
  cycleOrders: [
    {
      value: 1,
      text: 'First Cycle'
    },
    {
      value: 2,
      text: 'Second Cycle'
    }
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_ORG_CHART_STRUCTURES(state, data) {
    state.orgChartStructures = data
  },
  RECEIVE_EMPLOYEES(state, data) {
    state.employees = data
  },
  RECEIVE_SHIFTS(state, data) {
    state.shifts = data
  },
  SET_CYCLE_YEAR(state, cycle_year) {
    state.cycle_year = cycle_year
  },
  SET_CYCLE_MONTH(state, cycle_month) {
    state.cycle_month = cycle_month
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        cycle_month: context.state.cycle_month,
        cycle_year: context.state.cycle_year
      },
      attributes
    )
    return CalculatePayroll.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return CalculatePayroll.store(data)
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_employee_profiles: 'employee_id,employee_name_en'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchShift(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_shifts: 'shift_id,shift_name,shift_type'
      },
      ...attributes
    }

    return ShiftManagement.get({ params }).then(response => {
      context.commit('RECEIVE_SHIFTS', response.data)
      return Promise.resolve(response)
    })
  },

  async dataBeforeCreate(context) {
    if (!context.state.orgChartStructures.length > 0) {
      let response = await OrgChartStructure.get()
      context.commit('SET_ORG_CHART_STRUCTURES', response.data)
    }
  }
}
